import { getEnv } from '@/libs/Environment.js'

const usaRAAutomatico = getEnv().usa_registro_academico_automatico === 'S'

const dependentRegisterMenuInputs = [
    {
        key: 'dependent_name',
        display: 'Nome do dependente',
        placeHolder: 'Nome',
        type: 'text',
        required: true,
        maxlength: 50
    }
]

if (!usaRAAutomatico) {
    dependentRegisterMenuInputs.push({
        key: 'academic_register',
        display: 'Registro Acadêmico',
        placeHolder: 'RA',
        type: 'text',
        required: true,
        maxlength: 21
    })
}

export default {
    state: {
        registerFields: {
            currentPage: 0,
            personalData: [
                {
                    display: 'Instituição',
                    placeHolder: 'Instituição',
                    type: 'select',
                    optionDisplay: 'NMFANTCLIE',
                    required: true
                },
                {
                    display: 'Nome de Usuário',
                    placeHolder: 'Nome de Usuário',
                    type: 'text',
                    format: 'userName',
                    required: true
                },
                {
                    display: 'Senha',
                    placeHolder: 'Senha',
                    type: 'password',
                    required: true,
                    half: true
                },
                {
                    display: 'Confirmar Senha',
                    placeHolder: 'Confirmar Senha',
                    type: 'password',
                    required: true,
                    half: true
                },
                {
                    display: 'Nome',
                    placeHolder: 'Nome',
                    type: 'text',
                    required: true,
                    half: true,
                    maxlength: 50
                },
                {
                    display: 'CPF',
                    placeHolder: 'CPF',
                    type: 'text',
                    required: true,
                    half: true,
                    format: 'cpf'
                },
                {
                    display: 'E-mail',
                    placeHolder: 'E-mail',
                    type: 'email',
                    required: true,
                    format: 'email',
                    maxlength: 50
                },
                {
                    display: 'Celular',
                    placeHolder: 'Nº de celular',
                    type: 'text',
                    required: true,
                    half: false,
                    format: 'cellNumber',
                    maxlength: 25
                }
            ],
            addressData: [
                {
                    display: 'Endereço',
                    placeHolder: 'Endereço',
                    type: 'text',
                    required: true,
                    maxlength: 50
                },
                {
                    display: 'CEP',
                    placeHolder: 'CEP',
                    type: 'text',
                    required: true,
                    half: true,
                    format: 'cep',
                    onBlurAction: 'fillAdressByCEP'
                },
                {
                    display: 'Número',
                    placeHolder: 'Número',
                    type: 'text',
                    required: true,
                    half: true,
                    maxlength: 5,
                    format: 'number'
                },
                {
                    display: 'Complemento',
                    placeHolder: 'Complemento',
                    type: 'text',
                    required: false,
                    half: true,
                    maxlength: 100
                },
                {
                    display: 'Referência',
                    placeHolder: 'Referência',
                    type: 'text',
                    required: false,
                    half: true,
                    maxlength: 100
                },
                {
                    display: 'UF',
                    placeHolder: 'UF',
                    type: 'select',
                    optionDisplay: 'SGESTADO',
                    required: true,
                    half: false
                },
                {
                    display: 'Município',
                    placeHolder: 'Município',
                    optionDisplay: 'NMMUNICIPIO',
                    type: 'select',
                    required: true
                },
                {
                    display: 'Bairro',
                    placeHolder: 'Bairro',
                    type: 'text',
                    required: true,
                    maxlength: 100
                }
            ]
        },
        dependentRegisterMenu: {
            isVisible: false,
            inputs: dependentRegisterMenuInputs
        }
    },
    mutations: {
        // change current page
        setRegisterPage (state, pageNumber) {
            state.registerFields.currentPage = pageNumber
        },
        setDependentMenuVisibility (state) {
            state.dependentRegisterMenu.isVisible = !state.dependentRegisterMenu.isVisible
        },
        setClientsOptions (state, clients) {
            state.registerFields.personalData[0].options = clients
        },
        setStatesOptions (state, states) {
            state.registerFields.addressData[4].options = states
        },
        setCitiesOptions (state, cities) {
            state.registerFields.addressData[5].options = cities
        }
    },
    actions: {
        // change current page
        setRegisterPage ({ commit }, pageNumber) {
            commit('setRegisterPage', pageNumber)
        },
        changeDependentMenuVisibility ({ commit }) {
            commit('setDependentMenuVisibility')
        },
        setStatesOptions ({ commit }, clients) {
            commit('setStatesOptions', clients)
        },
        setClientsOptions ({ commit }, states) {
            commit('setClientsOptions', states)
        },
        setCitiesOptions ({ commit }, cities) {
            commit('setCitiesOptions', cities)
        }
    },
    getters: {
        registerFields: (state) => state.registerFields,
        dependentRegisterMenu: (state) => state.dependentRegisterMenu
    }
}
